import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
// 引入字体
import '@fontsource/roboto'
import '@fontsource/noto-sans-sc'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}


app.use(ElementPlus)
app.use(router)

// 屏蔽无害的 ResizeObserver loop 错误（Chrome/Edge bug）——必须在最前面
const _origOnerror = window.onerror
window.onerror = function (msg) {
  if (typeof msg === 'string' && msg.includes('ResizeObserver')) {
    return true
  }
  return _origOnerror ? _origOnerror.apply(this, arguments) : false
}

app.mount('#app')